import { render, staticRenderFns } from "./UmpanBalikBerkelanjutan.vue?vue&type=template&id=51c4e3af&scoped=true&lang=html&"
import script from "./UmpanBalikBerkelanjutan.vue?vue&type=script&lang=js&"
export * from "./UmpanBalikBerkelanjutan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c4e3af",
  null
  
)

export default component.exports